import React from 'react';
import "./style.css";
import logo from "../header/Hover Systems logo.png";
import { useTranslation } from "react-i18next";

const Contacts = () => {
  const { t } = useTranslation();

  return (
    <section id="Contacts">
      <div className='contactsBlock'>  
        <div className="info">
          <h1>{t("contacts.title")}</h1>
          <p>{t("contacts.description")}</p>
        </div>

        <div className='contactContent'>
          <div className='contactColumns'>
            <div className='logoBox'>
              <img src={logo} alt="Logo"/>
            </div>
            <p>{t("contacts.founder")}</p>
            <p>{t("contacts.position")}</p>
          </div>

          <div className='contactColumns'>
            <p><span>{t("contacts.addressLabel")}</span> {t("contacts.address")}</p>
            <p><span>{t("contacts.telLabel")}</span> {t("contacts.tel")}</p>
            <p><span>{t("contacts.emailLabel")}</span> {t("contacts.email")}</p>
            <p><span> </span> {t("contacts.email2")}</p>
          </div>
        </div>
      </div>
      <div className='wallpaper2'>

      </div>
    </section>
  )
}

export default Contacts;
